<ui-page-header [showBackButton]="true">Ihr Anliegen</ui-page-header>

<div class="section-wrapper">
  @if (ticketResource.isLoading()) {
    <ui-srm-details-skeleton></ui-srm-details-skeleton>
  } @else if (ticketResource.error() || !ticketResource.value()) {
    <div class="error-container">
      <ui-icon faName="exclamation-triangle" faStyle="light"></ui-icon>
      <h3>Das Ticket <strong>{{ ticketIdentifier() }}</strong> existiert nicht oder wurde bereits gelöscht.</h3>
      <p><strong>Bitte beachten Sie:</strong> Abgeschlossene Tickets werden nach 6 Monaten automatisch entfernt.</p>
    </div>
  } @else {
    <div class="details-content">
      <ui-segmented-progress-bar [steps]="steps" [activeStep]="currentStatus()" [labels]="statusLabels"></ui-segmented-progress-bar>

      <ui-srm-ticket-item [ticket]="ticket()!"></ui-srm-ticket-item>

      @if (hasCompleted()) {
        <div class="solution-card">
          <span class="status-icon">
            <ui-icon faName="check-circle" faStyle="light"></ui-icon>
          </span>
          <div class="solution-container">
            <p class="solution-title">Unsere Lösung</p>

            @if (solutionComment()) {
              <p class="solution-info">Lösungsbeschreibung: <strong>{{ solutionComment() }}</strong></p>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
